import { useCallback } from "react";
import { useInformationPageCompanyInformationSectionT } from "src/translation-hooks/information-page-company-information-section";

export const usePaymentTermsTranslation = () => {
  const t = useInformationPageCompanyInformationSectionT();

  // TODO ADAR: Update translation once backend is done
  const getPaymentTermsTranslation = useCallback(
    (state: string) => {
      return state;
    },
    [t]
  );
  return { getPaymentTermsTranslation };
};
